
import { MapTo } from '@adobe/aem-react-editable-components';
import SsnModule, { SsnModuleEditConfig } from './SsnModule';

export default MapTo('cob-corp-acquisition/components/creditonebank/ssn-module')(SsnModule, SsnModuleEditConfig);